export default "__VITE_ASSET__CplR__Xj__"